import Cookies from 'js-cookie';

import { STORAGE } from '@hero/constants/storage';

const getItem = key => {
  try {
    const localItem = localStorage.getItem(key);
    const localItemExpires = localStorage.getItem(`${key}-expires`);

    if (localItemExpires && new Date() > new Date(localItemExpires)) {
      localStorage.removeItem(key);
      localStorage.removeItem(`${key}-expires`);
      return undefined;
    } else {
      return localItem;
    }
  } catch (error) {
    throw new Error(`Error getting item ${key} from localStorage`, error);
  }
};

const setItem = (key, value, options = {}) => {
  try {
    localStorage.setItem(key, value);
    if (options.expires) {
      localStorage.setItem(`${key}-expires`, options.expires.toISOString());
    }
  } catch (error) {
    throw new Error(`Error storing item ${key} to localStorage`, error);
  }
};

const removeItem = key => {
  try {
    localStorage.removeItem(key);
    Cookies.remove(key);
  } catch (error) {
    throw new Error(`Error removing item ${key} from localStorage`, error);
  }
};

const getUnderMaintenance = () => {
  return getItem(STORAGE.underMaintenance);
};

const getUserToken = () => {
  return getItem(STORAGE.userToken);
};

const setUserToken = (value, options) => {
  setItem(STORAGE.userToken, value, options);
};

const removeUserToken = () => {
  removeItem(STORAGE.userToken);
};

const getOrganizationCode = () => {
  return getItem(STORAGE.organizationCode);
};

const setOrganizationCode = (value, options) => {
  setItem(STORAGE.organizationCode, value, options);
};

const removeOrganizationCode = () => {
  removeItem(STORAGE.organizationCode);
};

const getSsoLogin = () => {
  sessionStorage.getItem(STORAGE.ssoLogin);
};

const updateSsoLogin = value => {
  sessionStorage.setItem(STORAGE.ssoLogin, value);
};

const removeSsoLogin = () => {
  sessionStorage.removeItem(STORAGE.ssoLogin);
};

const getBrowserUUID = () => {
  return getItem(STORAGE.browserUUID);
};

const setBrowserUUID = (value, options) => {
  setItem(STORAGE.browserUUID, value, options);
};

const removeBrowserUUID = () => {
  removeItem(STORAGE.browserUUID);
};

const getClickStreamGuessToken = () => {
  return getItem(STORAGE.clickStreamGuessToken);
};

const setClickStreamGuessToken = (value, options) => {
  setItem(STORAGE.clickStreamGuessToken, value, options);
};

const removeClickStreamGuessToken = () => {
  removeItem(STORAGE.clickStreamGuessToken);
};

export const storage = {
  getUnderMaintenance,
  getUserToken,
  setUserToken,
  removeUserToken,
  getOrganizationCode,
  setOrganizationCode,
  removeOrganizationCode,
  removeSsoLogin,
  updateSsoLogin,
  getSsoLogin,
  getBrowserUUID,
  setBrowserUUID,
  removeBrowserUUID,
  getClickStreamGuessToken,
  setClickStreamGuessToken,
  removeClickStreamGuessToken
};
